var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7556 0.82666H11.5108C5.61875 0.82666 0.827148 5.61826 0.827148 11.5103V34.6581C0.827148 35.1304 1.01475 35.5833 1.34867 35.9172C1.6826 36.2511 2.13551 36.4387 2.60775 36.4387H25.7556C31.6476 36.4387 36.4392 31.6471 36.4392 25.7551V11.5103C36.4392 5.61826 31.6476 0.82666 25.7556 0.82666ZM13.2896 27.5357H9.73016V23.9763L19.5769 14.1438L23.1363 17.7032L13.2896 27.5357ZM24.8154 16.0241L21.256 12.4647L23.9696 9.75282L27.5291 13.3122L24.8154 16.0241Z",
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.8a4e0e4bbcf440c0a449c431c93e67bb.svg";
export { ForwardRef as ReactComponent };